// TODO: working on creating the phone number formatting, you can check it out in the textMaskCustom component from 'react-text-mask' package

import React, { Fragment } from 'react';
import classNames from 'classnames';
import { withRouter } from 'common/utils/router.util';
import { withStyles } from '@mui/styles'
import {
  Grid,
  TextField,
  Typography,
  MenuItem,
  Divider,
} from '@mui/material';
import styles from './styles';
import { withSnackbar } from 'notistack';
import compose from 'recompose/compose';
import MaskedInput from 'react-text-mask';
import PropTypes from 'prop-types';
import BrokerageOfficeFields from 'views/AgentDetails/component/BrokerageOfficeFields';


const TextMaskCustom = React.memo((props) => {
  const { inputRef, ...other } = props;
  return (
    <MaskedInput
      {...other}
      ref={ref => {
        if (typeof inputRef === 'function') {
          inputRef(ref ? ref.inputElement : null);
        }
      }}
      mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
      placeholderChar={'\u2000'}
      showMask={false}
      guide={true}
      keepCharPositions={false}
    />
  );
});

TextMaskCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

const Step1 = props => {
  const {
    classes,
    className,
    handleFieldChange,
    validateRegisterEmail,
    haveErrors,
    registerAgentData,
    onBrokerageValuesChange,
  } = props;
  const rootClassName = classNames(classes.root, className);
  const { values, touched, errors, designationData } = props;

  const showFirstNameError = touched.firstName && errors.firstName;
  const showLastNameError = touched.lastName && errors.lastName;
  const showEmailError = touched.emailAddress && errors.emailAddress;
  const showAgentDreNumberError = touched.agentLicenseNumber && errors.agentLicenseNumber;
  const showMobilePhoneError = touched.mobilePhone && errors.mobilePhone;
  const showPasswordError = touched.password && errors.password;
  const showConfirmPasswordError = touched.confirmPassword && errors.confirmPassword;
  const showDesignationError = touched.agentDesignation && errors.agentDesignation;

  return (
    <Fragment>
      <Grid container className={classes.grid} spacing={0}>
        <Grid item lg={4}>
          <div className={classes.field}>
            <TextField
              className={classes.textField}
              label="First Name"
              size="small"
              type="text"
              required
              name="firstName"
              value={values.firstName}
              error={haveErrors(showFirstNameError)}
              onChange={event => {
                handleFieldChange('firstName', event.target.value, event);
              }}
            />
            {showFirstNameError && (
              <Typography className={classes.fieldError} variant="body2">
                {errors.firstName[0]}
              </Typography>
            )}
          </div>
        </Grid>

        <Grid item lg={4}>
          <div className={classes.field}>
            <TextField
              className={classes.textField}
              label="Last Name"
              size="small"
              type="text"
              required
              name="lastName"
              value={values.lastName}
              error={haveErrors(showLastNameError)}
              onChange={event => {
                handleFieldChange('lastName', event.target.value, event);
              }}
            />
            {showLastNameError && (
              <Typography className={classes.fieldError} variant="body2">
                {errors.lastName[0]}
              </Typography>
            )}
          </div>
        </Grid>
        <Grid item lg={4}>
          <div className={classes.field}>
            <TextField
              id="select-agent-designation"
              select
              label="Select Your Designation"
              className={classes.textField}
              value={values.agentDesignation}
              required
              error={haveErrors(showDesignationError)}
              onChange={event => {
                handleFieldChange(
                  'agentDesignation',
                  event.target.value,
                  event
                );
              }}
              SelectProps={{
                MenuProps: {
                  className: classes.menu,
                },
              }}
              size="small"
            >
              {designationData.map(option => (
                <MenuItem key={option.listgenDesignationID} value={option.listgenDesignationName}>
                  {option.listgenDesignationName}
                </MenuItem>
              ))}
            </TextField>
            {showDesignationError && (
              <Typography className={classes.fieldError} variant="body2">
                {errors.agentDesignation[0]}
              </Typography>
            )}
          </div>
        </Grid>
      </Grid>

      <Grid container className={classes.grid} spacing={0}>
        <Grid item lg={4}>
          <div className={classes.field}>
            <TextField
              className={classNames(
                classes.textField,
                classes.dropdownTopMargin
              )}
              label="Agent License Number"
              size="small"
              type="text"
              required
              name="agentLicenseNumber"
              value={values.agentLicenseNumber}
              error={haveErrors(showAgentDreNumberError)}
              onChange={event => {
                handleFieldChange(
                  'agentLicenseNumber',
                  event.target.value,
                  event
                );
              }}
            />
            {showAgentDreNumberError && (
              <Typography className={classes.fieldError} variant="body2">
                {errors.agentLicenseNumber[0]}
              </Typography>
            )}
          </div>
        </Grid>
        <Grid item lg={4}>
          <div className={classNames(classes.field)}>
            <TextField
              className={classNames(
                classes.textField,
                classes.dropdownTopMargin
              )}
              label="Mobile Phone"
              size="small"
              variant="outlined"
              required
              name="mobilePhone"
              value={values.mobilePhone || ''}
              error={haveErrors(showMobilePhoneError)}
              onChange={event => {
                handleFieldChange('mobilePhone', event.target.value, event);
              }}
              InputProps={{
                inputComponent: TextMaskCustom,
              }}
            />
            {showMobilePhoneError && (
              <Typography className={classes.fieldError} variant="body2">
                {errors.mobilePhone[0]}
              </Typography>
            )}
          </div>
        </Grid>
        <Grid item lg={4}>
          <div className={classes.field}>
            <TextField
              className={classNames(
                classes.textField,
                classes.dropdownTopMargin
              )}
              label="Email"
              size="small"
              type="text"
              required
              name="emailAddress"
              value={values.emailAddress}
              error={haveErrors(showEmailError)}
              onBlur={event => {
                validateRegisterEmail();
              }}
              onChange={event => {
                handleFieldChange('emailAddress', event.target.value, event);
              }}
            />
            {showEmailError && (
              <Typography className={classes.fieldError} variant="body2">
                {errors.emailAddress[0]}
              </Typography>
            )}
          </div>
        </Grid>
      </Grid>

      <Grid container className={classes.grid} spacing={0}>
        <Grid item lg={4}>
          <div className={classes.field}>
            <TextField
              className={classNames(
                classes.textField,
                classes.dropdownTopMargin
              )}
              label="Password"
              size="small"
              type="password"
              required
              name="password"
              value={values.password}
              error={haveErrors(showPasswordError)}
              inputProps={{ minLength: 8 }}
              onChange={event => {
                handleFieldChange('password', event.target.value, event);
              }}
            />
            {showPasswordError && (
              <Typography className={classes.fieldError} variant="body2">
                {errors.password[0]}
              </Typography>
            )}
          </div>
        </Grid>
        <Grid item lg={4}>
          <div className={classes.field}>
            <TextField
              className={classNames(
                classes.textField,
                classes.dropdownTopMargin
              )}
              label="Confirm Password"
              size="small"
              type="password"
              required
              name="confirmPassword"
              value={values.confirmPassword}
              error={haveErrors(showConfirmPasswordError)}
              inputProps={{ minLength: 8 }}
              onChange={event => {
                handleFieldChange('confirmPassword', event.target.value, event);
              }}
            />
            {showConfirmPasswordError && (
              <Typography className={classes.fieldError} variant="body2">
                {errors.confirmPassword[0]}
              </Typography>
            )}
          </div>
        </Grid>
      </Grid>

      <Grid container className={classes.grid} spacing={0}>
        <Grid item lg={12}>
          <div className={classes.brokerageSection}>
            <Typography
              className={classes.brokerageSectionTitle}
              variant="subtitle1"
            >
              Brokerage Office & Managing Broker
            </Typography>
            <Divider />
            <BrokerageOfficeFields
              layout="split"
              values={values}
              errors={errors}
              countyID={registerAgentData && registerAgentData.countyID}
              brokerageName={registerAgentData && registerAgentData.brokerageName}
              onValuesChange={onBrokerageValuesChange}
            />
          </div>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default compose(
  withRouter,
  withSnackbar,
  withStyles(styles)
)(Step1);
